/**
 * MUI palette mapped from hyzebra Design System v1.6 tokens.
 */
import { CustomTypography } from 'src/themes/types';
import { adminTokens } from 'src/views/common/adminTokens';

export default function themePalette(theme: CustomTypography) {
    const isDark = theme?.customization?.navType === 'dark';

    if (isDark) {
        return {
            mode: 'dark' as const,
            common: { black: theme.colors?.darkPaper },
            primary: {
                light: theme.colors?.darkPrimaryLight,
                main: theme.colors?.darkPrimaryMain,
                dark: theme.colors?.darkPrimaryDark,
                200: theme.colors?.darkPrimary200,
                800: theme.colors?.darkPrimary800,
            },
            secondary: {
                light: theme.colors?.darkSecondaryLight,
                main: theme.colors?.darkSecondaryMain,
                dark: theme.colors?.darkSecondaryDark,
                200: theme.colors?.darkSecondary200,
                800: theme.colors?.darkSecondary800,
            },
            error: {
                light: theme.colors?.errorLight,
                main: adminTokens.errorSolid,
                dark: theme.colors?.errorDark,
            },
            warning: {
                light: theme.colors?.warningLight,
                main: theme.colors?.warningMain!,
                dark: theme.colors?.warningDark!,
            },
            success: {
                light: adminTokens.successBg,
                main: adminTokens.green600,
                dark: adminTokens.green700,
            },
            grey: {
                50: theme.colors?.grey50!,
                100: theme.colors?.grey100!,
                500: theme.darkTextSecondary!,
                600: theme.heading!,
                700: theme.darkTextPrimary!,
                900: theme.textDark!,
            },
            text: {
                primary: theme.darkTextPrimary!,
                secondary: theme.darkTextSecondary!,
            },
            background: {
                paper: theme.paper!,
                default: theme.backgroundDefault!,
            },
            divider: theme.divider,
        };
    }

    return {
        mode: 'light' as const,
        common: { black: adminTokens.navy900 },
        primary: {
            light: adminTokens.gray100,
            main: adminTokens.ink,
            dark: adminTokens.inkHover,
            200: adminTokens.gray200,
            800: adminTokens.navy800,
        },
        secondary: {
            light: adminTokens.ai100,
            main: adminTokens.ai600,
            dark: adminTokens.ai700,
            200: adminTokens.gray200,
            800: adminTokens.navy700,
        },
        error: {
            light: adminTokens.errorBg,
            main: adminTokens.errorSolid,
            dark: adminTokens.errorText,
        },
        warning: {
            light: adminTokens.warningBg,
            main: '#D97706',
            dark: adminTokens.warningText,
        },
        success: {
            light: adminTokens.successBg,
            main: adminTokens.green600,
            dark: adminTokens.green700,
        },
        orange: {
            light: adminTokens.warningBg,
            main: '#D97706',
            dark: adminTokens.warningText,
        },
        grey: {
            50: adminTokens.gray50,
            100: adminTokens.gray100,
            200: adminTokens.gray200,
            300: adminTokens.gray300,
            400: adminTokens.gray400,
            500: adminTokens.gray500,
            600: adminTokens.gray600,
            700: adminTokens.navy800,
            900: adminTokens.navy900,
        },
        text: {
            primary: adminTokens.navy800,
            secondary: adminTokens.gray600,
            disabled: adminTokens.gray400,
        },
        background: {
            paper: adminTokens.surface,
            default: adminTokens.bg,
        },
        divider: adminTokens.gray200,
    };
}
